import * as z from "zod";

export const disconnectRithumIntegration = {
  name: "disconnectRithumIntegration" as const,
  input: z.object({}),
  output: z.object({ success: z.boolean() }),
};
